import { PurchasesService } from './../../../../inventory/purchases/purchases.service';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import { FileService } from './../../../../modules/shared/services/file.service';
import { FormControlListIds } from './../../../../modules/shared/constants/formcontrol-list.constants';
import { FormErrorHandler } from './../../../../modules/shared/helpers/form-error-handler.helper';
import { WF_SO_FORM_FIELDS } from './../../models/workflow-sales-order-fields.constants';
import { UtilityService } from './../../../../inventory/sales-order/utils/utility.service';
import { ProductsService } from './../../../../inventory/products/products.service';
import { SalesOrderService } from './../../../../inventory/sales-order/sales-order.service';
import { ParseHelper } from './../../../../modules/shared/parse.helper';
import { BillOrderModuleId, CMOrderModuleId, EstimateOrderModuleId, InvoiceOrderModuleId, OrderModuleId, PurchaseOrderModuleId, SOModuleId, VendorCreditModuleId, VendorModuleId } from './../../../../modules/shared/constants/modules.constant';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { WorkflowModelsNS } from '../../models/add-update-workflow.models';
import { ProductSelectionService } from '../../../../modules/shared/services/product-selection.service';
import { MessageService } from 'primeng/api';
import { AppMainService } from '../../../../app-main.service';
import { BehaviorSubject, catchError, forkJoin, of, Subject, takeUntil } from 'rxjs';
import { Status } from '../../../../modules/shared/models/status';
import { scrollToError } from '../../../../modules/shared/helpers/scroll-to-error.helper';
import * as _ from "lodash";
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { uploadFiles, validateFileSize, validateFiles } from 'src/app/modules/shared/upload-files';
import { TypeIds } from 'src/app/inventory/sales-order/constants/constants';
import { ImportserialService } from 'src/app/modules/shared/services/importserial.service';
import { ShippingtermService } from 'src/app/configurations/inventory/setup/shippingterm/shippingterm.service';
import { ShippingmethodService } from 'src/app/configurations/inventory/setup/shippingmethod/shippingmethod.service';
import { PaymenttermService } from 'src/app/configurations/inventory/setup/paymentterm/paymentterm.service';
import { PaymentmethodService } from 'src/app/configurations/inventory/setup/paymentmethod/paymentmethod.service';

interface DependentApiList {
    config: boolean,
    discount: boolean,
    discountList: boolean
}
@Component({
  selector: 'app-workflow-create-record-dialog',
  templateUrl: './workflow-create-record-dialog.component.html',
  styleUrls: ['./workflow-create-record-dialog.component.scss']
})

export class WorkflowCreateRecordDialogComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();
    private dependentLoadedApis: BehaviorSubject<DependentApiList> = new BehaviorSubject<DependentApiList>({
        config: false,
        discount: false,
        discountList: false
    });

    @Input() viewOnly: boolean = false;
    @Input() displayCreateRecordDialog: boolean = false;
    @Input() selectedParentModule: SavedSearchNS.IObjectType;
    @Input() fromUpdateRecord: boolean = false;
    @Input() selectedActionCreateRecord: WorkflowModelsNS.WorkflowAddEditActionCreateRecord = null;
    @Output() savedCreateRecord = new EventEmitter<WorkflowModelsNS.WorkflowAddEditActionCreateRecord>();
    @Output() dialogClosed = new EventEmitter<boolean>();

    popupHeader: string = "Create Record";

    dropdownIcon: string = 'fa fa-caret-down';
    typeIds = TypeIds;
    modules: any[] = [];
    accountModules = [
        // {id:1, name:"Account"},
        // {id:2, name:"Lead"},
        {id: SOModuleId, recordType: WorkflowModelsNS.WorkflowCreateRecordType.SalesOrder, name: 'Sales Order'},
        {id: InvoiceOrderModuleId, recordType: WorkflowModelsNS.WorkflowCreateRecordType.Invoice, name: 'Invoice'},
        {id: CMOrderModuleId, recordType: WorkflowModelsNS.WorkflowCreateRecordType.CreditMemo, name: 'Credit Memo'},
        {id: EstimateOrderModuleId, recordType: WorkflowModelsNS.WorkflowCreateRecordType.Estimate, name: 'Estimates'}
    ];
    vendorModules = [
        {id: PurchaseOrderModuleId, recordType: WorkflowModelsNS.WorkflowCreateRecordType.Purchase, name: 'Purchase'},
        {id: BillOrderModuleId, recordType: WorkflowModelsNS.WorkflowCreateRecordType.BillOrder, name: 'Bill'},
        {id: VendorCreditModuleId, recordType: WorkflowModelsNS.WorkflowCreateRecordType.VendorCredit, name: 'Vendor Credit'},
    ];
    // 2 Estimate, 3  Sales Order , 4 Invoicing   5 Customer Returns  6  Credit Memo
    salesOrderChannels = [{channelId: 3, channelName: 'Sales Order'}];
    invoiceOrderChannels = [{channelId: 4, channelName: 'Invoice'}];
    CMOrderChannels = [{channelId: 6, channelName: 'Credit Memo'}];
    estimateOrderChannels = [{channelId: 2, channelName: 'Estimates'}];
    purchaseOrderChannels = [{channelId: 1, channelName: 'Purchase Order'}];
    billOrderChannels = [{channelId: 3, channelName: 'Bill Order'}];
    vendorCreditChannels = [{channelId: 7, channelName: 'Vendor Credit'}];
    productSelectionFor = [SOModuleId,InvoiceOrderModuleId,CMOrderModuleId,EstimateOrderModuleId,PurchaseOrderModuleId,BillOrderModuleId,VendorCreditModuleId];
    selectedRecordModule: any = null;
    channels: any[] = [];
    showSODetail = false;
    purchaseListTB: WorkflowModelsNS.WorkflowAddEditActionRecordProductDetails[] = [];
    productGrandTotal: number = 0;
    selectedPL;
    displayProductSelectionModal = false;
    moduleName = '';
    selectedProductsList: WorkflowModelsNS.WorkflowAddEditActionRecordProductDetails[] = [];
    allLocations: any[] = [];
    selectedLocation: any = null;
    headerText = "Products List";
    isVisibleLocation = false;
    pricebookConfig: boolean = false;

    //Sales Order
    orderTemplates: any[] = [];
    salesOrderTemplates: any[] = [];
    orderObjId: number = OrderModuleId;
    orderCustomAttributes: any[] = [];
    allDiscounts: any[] = [];
    discountEnabled: boolean = false;

    //Sales Order Form
    allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif'];
    formControlListIds = FormControlListIds;
    checkedFields: any = {};
    checkedFieldList: any = [];
    tableFieldsCount: number = 0;

    salesOrderForm: FormGroup;
    bundleIndex: number = -1;
    formSubmitted: boolean = false;
    loadingFormSave: boolean = false;
    isUnsavedData: boolean = false;
    detailsFormErrors: any = {};
    formErrorHandler: FormErrorHandler = new FormErrorHandler();
    taxInfoTooptip: string = "";
    combinedCustomFields = {
        billing_address_item: [],
        shipping_address_item: [],
        misc_item: [],
        section_item: [],
        footer_item: [],
        message_item: [],
        other1_item: [],
        other2_item: [],
        other3_item: [],
    };

     // fraction digits
     fractionDigits: number = 0;
     qtyFractionDigits: number = 0;
     measurementUnits  = [];
     decimalPlacesMap: { [key: number]: number } = {};


    allTax: any[] = [];
    allShippingMethods: any[] = [];
    allPaymentTerms: any[] = [];
    allPaymentMethods: any[] = [];
    allShippingTerms: any[] = [];
    allUser: any[] = [];
    orderChannels: any[] = [];
    shippingMethods: any[] = [];
    aggregateDiscount: boolean = false;
    footerTaxEnabled = false;
    taxDesc;

    /** Additional Discounts */
    discountOptions: any[] = [];
    additionalDiscounts: any = [];
    additionalDiscountRateTypes: any = [];
    additionalDiscountAmount: Number = 0;

    // additional Fees
    additionalFees: any[] = [];
    totalAdditionalFee: number = 0;
    productsTotalAdditionalFee: number = 0;

    constructor(
        private messageService: MessageService,
        private formBuilder: FormBuilder,
        private appMainService: AppMainService,
        private productSelectionService: ProductSelectionService,
        private salesOrderService: SalesOrderService,
        private purchaseService: PurchasesService,
        private productsService: ProductsService,
        private utilityService: UtilityService,
        private fileService: FileService,
        private importService: ImportserialService,
        private shippingtermService: ShippingtermService,
        private shippingMethodService: ShippingmethodService,
        private paymenttermService: PaymenttermService,
        private paymentmethodService: PaymentmethodService,
    ) { }

    ngOnInit(): void {
        this.modules = this.accountModules;
        if(this.selectedParentModule.objectId==VendorModuleId){
            this.modules = this.vendorModules;
        }

        this.initOrderForm();

        if(this.selectedActionCreateRecord){
            if(this.selectedActionCreateRecord?.objectId==246){
                this.selectedActionCreateRecord.objectId = SOModuleId;
            }

            this.selectedRecordModule = this.modules.find(m=> m.id==this.selectedActionCreateRecord.objectId);
            this.selectModule();
        }else if(this.fromUpdateRecord && this.selectedParentModule){
            this.selectedRecordModule = this.modules.find(m=> m.id==this.selectedParentModule.objectId);
            this.selectModule();
        }

        this.popupHeader = this.fromUpdateRecord ? `${this.selectedRecordModule.name} Update Record` : "Create Record";
        this.getFractionDigits();
        this.getQtyDecimalDigits();
        this.fetchUnitOfMeasureCategories();
    }

    selectModule(){
        this.purchaseListTB = [];
        this.taxInfoTooptip = `Tax will be calculated after creating ${this.selectedRecordModule?.name} from Workflow Process`;
        switch (this.selectedRecordModule?.id) {
            case SOModuleId:
                this.channels = ParseHelper.DeepCopy(this.salesOrderChannels);
                break;
            case InvoiceOrderModuleId:
                this.channels = ParseHelper.DeepCopy(this.invoiceOrderChannels);
                break;
            case CMOrderModuleId:
                this.channels = ParseHelper.DeepCopy(this.CMOrderChannels);
                break;
            case EstimateOrderModuleId:
                this.channels = ParseHelper.DeepCopy(this.estimateOrderChannels);
                break;
            case PurchaseOrderModuleId:
                this.channels = ParseHelper.DeepCopy(this.purchaseOrderChannels);
                break;
            case BillOrderModuleId:
                this.channels = ParseHelper.DeepCopy(this.billOrderChannels);
                break;
            case VendorCreditModuleId:
                this.channels = ParseHelper.DeepCopy(this.vendorCreditChannels);
                break;
            default:
                break;
        }

        this.initOrderForm();
        this.loadData();
        this.getAllLocations();
    }

    loadData() {
        this.appMainService.isShowSpinner("loadData");
        let templateObservable = this.salesOrderService.getAllOrdersChannel("Orders Template").pipe(catchError((error) => this.handleError("Template", error)));

        if([PurchaseOrderModuleId,BillOrderModuleId,VendorCreditModuleId].includes(this.selectedRecordModule?.id)){
            templateObservable = this.purchaseService.getPOConfigurations('Purchase').pipe(catchError((error) => this.handleError("Template", error)));
        }

        const taxObservable = this.salesOrderService.getAllTax().pipe(catchError((error) => this.handleError("Payment Term", error)));
        //const orderChannelsObservable = this.salesOrderService.getAllOrdersChannel("Orders Type").pipe(catchError((error) => this.handleError("Order Channels", error)));
        const shippingTermObservable = this.shippingtermService.getShippingTermList().pipe(catchError((error) => this.handleError("Shipping Term", error)));
        const allUserObservable = this.salesOrderService.getAllUser().pipe(catchError((error) => this.handleError("All User", error)));
        //const allLocationObservable = this.salesOrderService.getAllLocations("0", "0", "").pipe(catchError((error) => this.handleError("All Location", error)));
        const allTiersObservable = this.productsService.getAllTiers().pipe(catchError((error) => this.handleError("All Tiers", error)));
        //const discountSelectionObservable = this.salesOrderService.getAllDiscountOption("TierApplicationRule").pipe(catchError((error) => this.handleError("Discount Selection", error)));
        const additionalDiscountObservable = this.salesOrderService.getDiscounts(false).pipe(catchError((error) => this.handleError("Discount", error)));
        const additionalFeesObservable = this.salesOrderService.getAdditionalFees().pipe(catchError((error) => this.handleError("Additional Fees", error)));
        const discountConfigObservable = this.salesOrderService.getAllDiscount().pipe(catchError((error) => this.handleError("Discount", error)));
        const shippingMethodObservable = this.shippingMethodService.getShippingMethodList().pipe(catchError((error) => this.handleError("Shipping Method", error)));
            console.log("slectedParentModule",this.selectedParentModule);
        
        const isVendorModule = [VendorModuleId].includes(this.selectedParentModule?.objectId);
        const paymentTermIndex = isVendorModule ? 1 : 0;
        const paymentTermIndexForVendor = isVendorModule ? 3 : 1;

        const getPaymentTermObservable = this.paymenttermService.getPaymentTermList(paymentTermIndex).pipe(catchError((error) => this.handleError("Payment Term", error)));
        const paymentMethodObservable = this.paymentmethodService.getPaymentMrthodList(paymentTermIndexForVendor).pipe(catchError((error) => this.handleError("Payment Method", error)));

        forkJoin([templateObservable, taxObservable, shippingTermObservable, allUserObservable, allTiersObservable, additionalDiscountObservable, additionalFeesObservable, discountConfigObservable, shippingMethodObservable, getPaymentTermObservable, paymentMethodObservable ]).subscribe(
            ([allTemplates, taxData, shippingTermData, allUserData, allTiersData, additionalDiscounts, additionalFees, discountConfig, shippingMethods, paymentTerms, paymentMethods ]) => {

                if([PurchaseOrderModuleId,BillOrderModuleId,VendorCreditModuleId].includes(this.selectedRecordModule?.id)){
                    this.setPurchaseTemplate(allTemplates);
                }else{
                    this.setTemplate(allTemplates);
                }

                this.setAllTaxData(taxData);
                this.setShippingTermData(shippingTermData);
                this.setAllUserData(allUserData);
                this.setAllTiersData(allTiersData);
                this.setAdditionalDiscounts(additionalDiscounts);
                this.setAdditionalFees(additionalFees);
                this.setDiscountConfig(discountConfig);
                this.setShippingMethods(shippingMethods);
                this.setPaymentMethods(paymentMethods);
                this.setPaymentTerm(paymentTerms);

                this.setOrderDetails();

                this.appMainService.isHideSpinner("loadData");
            },
            (error) => {
                this.appMainService.isHideSpinner("loadData");
                this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
            },
        );
    }

    setAllTaxData(res) {
        this.footerTaxEnabled = res?.item1;
        if (res?.item1) {
            this.allTax = res?.item2;
            if (this.allTax && this.allTax.length > 0) {
                this.taxDesc = this.allTax.filter((t) => t.isDefault == true)[0];
            }
        }
    }

    setShippingTermData(res) {
        if (res) {
            this.allShippingTerms = res;
        }
    }

    setAllUserData(res) {
        if (res) {
            this.allUser = res;
        }
    }

    setDiscountSelectionData(res) {
        if (res) {
            const aggregateDiscountValue = res?.filter((o) => o.name == "Aggregate Discount" && o.isDefault == true)[0];
            this.aggregateDiscount = aggregateDiscountValue ? true : false;
        }
    }

    setAllTiersData(res) {
        if (res) {
            this.pricebookConfig = res.item1;
        }
    }

    setAdditionalDiscounts(addDiscounts) {
        this.discountOptions = [];
        this.additionalDiscounts = [];
        if (addDiscounts && addDiscounts.length > 0) {
            this.additionalDiscounts = addDiscounts?.map((l) => ({ ...l, additionalDescription: `${l.description}(${l.type.description})`, typeDescription: l.type.description }));
            this.additionalDiscountRateTypes = [];
            this.discountOptions = this.utilityService.prepareDiscountOptions(addDiscounts);
        }
    }

    setAdditionalFees(addFees) {
        this.additionalFees = addFees?.map((l) => ({ ...l, additionalname: `${l.description}(${l.type.description})`, typeDescription: l.type.description }));
    }

    setDiscountConfig(res) {
        this.discountEnabled = res.item1;
    }

    setShippingMethods(shippingMethods) {
        this.allShippingMethods = shippingMethods?.filter((m) => m.statusId == Status.Active);
        this.shippingMethods = this.utilityService.prepareShippingMethods(this.allShippingMethods);
    }

    setPaymentMethods(paymentMethods) {
        this.allPaymentMethods = paymentMethods?.filter((m) => m.statusId == Status.Active);
    }

    setPaymentTerm(paymentTerms) {
        this.allPaymentTerms = paymentTerms?.filter((m) => m.statusId == Status.Active);
    }

    private handleError(apiName: string, error: any) {
        this.appMainService.isHideSpinner("loadData");
        this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
        return of(null);
    }

    setOrderDetails(){
        if(this.selectedActionCreateRecord){
            this.salesOrderForm.patchValue({
                id: this.selectedActionCreateRecord.id,
                isTableDiscountEnabled: this.selectedActionCreateRecord.isTableDiscountEnabled,
                paymentTermId: this.selectedActionCreateRecord.paymentTermId,
                paymentMethodId: this.selectedActionCreateRecord.paymentMethodId,
                shippingTermId: this.selectedActionCreateRecord.shippingTermId,
                shippingMethod: this.utilityService.findShippingMethodById(this.shippingMethods, this.selectedActionCreateRecord.shippingMethodId),
                salesRepId: this.selectedActionCreateRecord.salesRepId,
                discountId: this.selectedActionCreateRecord.discountId||null,
                discountTypeId: this.selectedActionCreateRecord.discountTypeId||null,
                discountAmount: this.selectedActionCreateRecord.discountAmount,
                addlDiscountId: this.selectedActionCreateRecord.addlDiscountId||null,
                addlDiscountTypeId: this.selectedActionCreateRecord.addlDiscountTypeId||null,
                addlDiscountAmount: this.selectedActionCreateRecord.addlDiscountAmount,
                handlingChargeId: this.selectedActionCreateRecord.handlingChargeId||null,
                handlingChargeTypeId: this.selectedActionCreateRecord.handlingChargeTypeId||null,
                handlingChargeAmount: this.selectedActionCreateRecord.handlingChargeAmount,
                isFreeShipping: this.selectedActionCreateRecord.isFreeShipping,
                shippingAmount: this.selectedActionCreateRecord.shippingAmount
            });

           this.setAddedProducts();
           this.calculateTotal(this.salesOrderForm.getRawValue().workflowCreateRecordProducts);
        }
       this.itemTotalCalulationInit();
    }

    //#region ***Order Form***
    initOrderForm(){
        this.detailsFormErrors = {};
        this.isUnsavedData = false;

        this.salesOrderForm = this.formBuilder.group({
            id: [0],
            selectedChannel: [this.channels[0],[Validators.required]],
            selectedLocation: [null,[Validators.required]],
            paymentTermId: [null],
            paymentMethodId: [null],
            shippingTermId: [null],
            shippingMethod: [null],
            salesRepId: [null],
            isTableDiscountEnabled: [false],
            discountId: [null],
            discountTypeId: [null],
            discountAmount: [0],
            calculatedDiscount: [0],
            addlDiscountId: [null],
            addlDiscountTypeId: [null],
            addlDiscountAmount: [0],
            calculatedAddlDiscount: [0],
            isFreeShipping: [false],
            shippingAmount: [0],
            handlingChargeId: [null],
            handlingChargeTypeId: [null],
            handlingChargeAmount: [0],
            calculatedHandlingAmount: [0],
            lineAmount: [0],
            lineTotalDiscount: [0],
            lineTotalHandlingFee: [0],
            subtotal: [0],
            orderTotal: [0],
            workflowCreateRecordProducts: this.formBuilder.array([]),
            customAttributes: this.formBuilder.array([])
        });

        if(this.viewOnly){
            this.salesOrderForm.disable();
        }

        this.formErrorHandler.handleErrors(this.salesOrderForm, this.detailsFormErrors, {
            selectedChannel: {
                required: "Select any channel"
            },
        });

        this.salesOrderForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe$)).subscribe(e => this.isUnsavedData = true);
    }

    saveCreateRecord(){
        this.saveSalesOrder();
        // switch (this.selectedRecordModule?.id) {
        //     case SOModuleId:
        //     case InvoiceOrderModuleId:
        //     case CMOrderModuleId:
        //     case EstimateOrderModuleId:
        //         this.saveSalesOrder();
        //         break;
        //     default:
        //         break;
        // }
    }

    saveSalesOrder(){
        if(this.salesOrderForm.invalid){
            this.salesOrderForm.markAllAsTouched();
            this.salesOrderForm.markAsDirty();
            this.formErrorHandler.showErrorOnSubmit();
            scrollToError();
            return;
        }

        const formValue = this.salesOrderForm.getRawValue();

        const createRecordData: WorkflowModelsNS.WorkflowAddEditActionCreateRecord = {
            id: this.selectedActionCreateRecord?.id||0,
            workflowActionId: this.selectedActionCreateRecord?.workflowActionId||0,
            createRecordType: this.selectedRecordModule.recordType,
            objectId: this.selectedRecordModule?.id,
            objectName: this.selectedRecordModule?.name,
            channelId: formValue.selectedChannel?.channelId,
            channelName: formValue.selectedChannel?.channelName,
            locationId: formValue.selectedLocation?.id,
            locationName: formValue.selectedLocation?.name,
            paymentTermId: formValue.paymentTermId||0,
            paymentMethodId: formValue.paymentMethodId||0,
            shippingTermId: formValue.shippingTermId||0,
            shippingMethodId: formValue.shippingMethod?.id||0,
            salesRepId: formValue.salesRepId||0,
            customAttributeInfos: this.customAttributeFormatForSave(),
            isTableDiscountEnabled: formValue.isTableDiscountEnabled,
            discountId: formValue.discountId||0,
            discountTypeId: formValue.discountTypeId||0,
            discountAmount: formValue.discountAmount,
            addlDiscountId: formValue.addlDiscountId||0,
            addlDiscountTypeId: formValue.addlDiscountTypeId||0,
            addlDiscountAmount: formValue.addlDiscountAmount,
            isFreeShipping: formValue.isFreeShipping,
            shippingAmount: formValue.shippingAmount,
            handlingChargeId: formValue.handlingChargeId||0,
            handlingChargeTypeId: formValue.handlingChargeTypeId||0,
            handlingChargeAmount: formValue.handlingChargeAmount,
            statusId: this.selectedActionCreateRecord?.statusId||Status.Active,
            workflowCreateRecordProducts: [],
            products: ParseHelper.DeepCopy(this.purchaseListTB)
        }

        this.salesOrderForm.getRawValue().workflowCreateRecordProducts.map(addedProduct=>{
            const productRecord = this.saveAddedProduct(addedProduct,createRecordData);
            createRecordData.workflowCreateRecordProducts.push(productRecord);

            if(addedProduct?.bundleDetails?.length>0){
                addedProduct?.bundleDetails.map(bundleProduct=>{
                    const bproductRecord = this.saveAddedProduct(bundleProduct,createRecordData);
                    createRecordData.workflowCreateRecordProducts.push(bproductRecord);
                })
            }
        });


        // Set removed product
        if(this.selectedActionCreateRecord){
            this.selectedActionCreateRecord.workflowCreateRecordProducts.map(addedProduct=>{
                const exist = createRecordData.workflowCreateRecordProducts.find(product=>product.id==addedProduct.id);
                if(!exist){
                    createRecordData.workflowCreateRecordProducts.push({...addedProduct,statusId: Status.Deleted});
                }
            })
        }

        this.savedCreateRecord.emit(createRecordData);
        this.closeCreateRecord();
    }

    saveAddedProduct(addedProduct: WorkflowModelsNS.WorkflowAddEditActionCreateRecordProducts, createRecordData: WorkflowModelsNS.WorkflowAddEditActionCreateRecord){

        const productRecord: WorkflowModelsNS.WorkflowAddEditActionCreateRecordProducts = {
            id: addedProduct.id,
            workflowActionCreateRecordId: createRecordData.id,
            productId: addedProduct.productId,
            typeId: addedProduct.typeId,
            productUOMId: addedProduct.productUOMId||0,
            discountId: addedProduct.discountId||0,
            discountTypeId: addedProduct.discountTypeId||0,
            discountAmount: addedProduct.discountAmount,
            handlingChargeId: addedProduct.handlingChargeId||0,
            handlingChargeTypeId: addedProduct.handlingChargeTypeId||0,
            handlingChargeAmount: addedProduct.handlingChargeAmount,
            productQty: addedProduct.productQty,
            productPrice: addedProduct.productPrice,
            bundleKitParentProductId: addedProduct.bundleKitParentProductId,
            statusId: Status.Active
        }

        return productRecord;
    }

    //#endregion

    //#region ***Custom Attributes***

    customAttributeFormatForSave(){
        const customAttributesValue = [];
        this.salesOrderForm.getRawValue().customAttributes?.map((customDetails: WorkflowModelsNS.WorkflowAddEditActionRecordSOCustoms)=>{
            const customValue: any = {
                customAttributeId: customDetails.customAttributeId,
                customAttributeValue: customDetails.customAttributeValue
            }

            switch (customDetails.formControlId) {
                case FormControlListIds.InputBox:
                    customValue.customAttributeValue = customDetails.customAttributeValue ? [customDetails.customAttributeValue] : [];
                    break;
                case FormControlListIds.RadioButton:
                    customValue.customAttributeValue = customDetails.customAttributeValue ? [customDetails.customAttributeValue] : [];
                    break;
                case FormControlListIds.DropDownList:
                    customValue.customAttributeValue = customDetails.customAttributeValue ? [customDetails.customAttributeValue] : [];
                    break;
                case FormControlListIds.Rating:
                    customValue.customAttributeValue = customDetails.customAttributeValue ? [customDetails.customAttributeValue.toString()] : [];
                    break;
                case FormControlListIds.ToggleButton:
                    customValue.customAttributeValue = customDetails.customAttributeValue ? ['true'] : ["false"];
                    break;
                case FormControlListIds.DatePicker:
                    customValue.customAttributeValue = customDetails.customAttributeValue ? [customDetails.customAttributeValue.toString()] : [];
                    break;
                case FormControlListIds.Picture:
                    customValue.customAttributeValue = customDetails.customAttributeValue?.length>0 ? customDetails.customAttributeValue.map(attach=> {return JSON.stringify(attach)})  : [];
                    break;
                case FormControlListIds.FileUpload:
                    customValue.customAttributeValue = customDetails.customAttributeValue?.length>0 ? customDetails.customAttributeValue.map(attach=> {return JSON.stringify(attach)})  : [];
                    break;
                default:
                    break;
            }
            customValue.customAttributeValue = customValue.customAttributeValue||[];
            customAttributesValue.push(customValue);
        })

        return customAttributesValue?.length>0 ? customAttributesValue : null;
    }

    generateCustomAttributeFields(){
        if(this.combinedCustomFields){
            const implementedSections = ['footer_item','billing_address_item','shipping_address_item','section_item','misc_item','message_item'];
            Object.keys(this.combinedCustomFields).filter(key=> implementedSections.includes(key)).map(key=>{
                const fields = this.combinedCustomFields[key].filter(f=> f.isChecked);
                fields.map(customField=>{

                    let pickListValues: any[] = customField?.pickListValues||[];

                    let customValue: any = null;

                    if(this.selectedActionCreateRecord?.customAttributeInfos?.length>0){

                        customValue = this.selectedActionCreateRecord?.customAttributeInfos.find(c=> c.customAttributeId==customField.id);

                        if(customValue && customValue.customAttributeValue?.length>0){
                            switch (customField.formControlId) {
                                case FormControlListIds.InputBox:
                                    customValue.customAttributeValue = customValue.customAttributeValue[0] ? customValue.customAttributeValue[0] : "";
                                    break;
                                case FormControlListIds.RadioButton:
                                    customValue.customAttributeValue = customValue.customAttributeValue[0] ? pickListValues.find(p=> p.name==customValue.customAttributeValue[0])?.name||null : null;
                                    break;
                                case FormControlListIds.DropDownList:
                                    customValue.customAttributeValue = customValue.customAttributeValue[0] ? pickListValues.find(p=> p.name==customValue.customAttributeValue[0])?.name||null : null;
                                    break;
                                case FormControlListIds.MultipleDropDownList:
                                    const mValues = customValue.customAttributeValue.filter(name=>pickListValues.find(p=> p.name==name));
                                    customValue.customAttributeValue = mValues?.length>0 ? mValues : null;
                                    break;
                                case FormControlListIds.CheckBox:
                                    const cValues = customValue.customAttributeValue.filter(name=>pickListValues.find(p=> p.name==name));
                                    customValue.customAttributeValue = cValues?.length>0 ? cValues : null;
                                    break
                                case FormControlListIds.Rating:
                                    customValue.customAttributeValue = customValue.customAttributeValue[0] ? parseInt(customValue.customAttributeValue[0]) : null;
                                    break;
                                case FormControlListIds.ToggleButton:
                                    customValue.customAttributeValue = customValue.customAttributeValue[0]=='true' ? true : false;
                                    break;
                                case FormControlListIds.DatePicker:
                                    customValue.customAttributeValue = customValue.customAttributeValue?.length>0 ? new Date(customValue.customAttributeValue[0]) : null ;
                                    break;
                                case FormControlListIds.Picture:
                                    customValue.customAttributeValue = customValue.customAttributeValue?.length>0 ? customValue.customAttributeValue.map(attach=> {return JSON.parse(attach)})  : null;
                                    break;
                                case FormControlListIds.FileUpload:
                                    customValue.customAttributeValue = customValue.customAttributeValue?.length>0 ? customValue.customAttributeValue.map(attach=> {return JSON.parse(attach)})  : null;
                                    break;
                                default:
                                    break;
                            }
                        }else{
                            customValue.customAttributeValue = null;
                        }
                    }

                    const fieldDetails: WorkflowModelsNS.WorkflowAddEditActionRecordSOCustoms = {
                        customAttributeId: customField.id,
                        sectionCode: key,
                        formControlId: customField.formControlId,
                        isRequired: customField.isRequired,
                        field: customField.name,
                        labelName: customField.name,
                        pickListValues: pickListValues,
                        customAttributeValue: customValue?.customAttributeValue||null
                    }

                    this.addCustomAttribute(fieldDetails);
                })

           });
        }
    }

    initCustomAttribute(customAttribute: WorkflowModelsNS.WorkflowAddEditActionRecordSOCustoms){
        return this.formBuilder.group({
            customAttributeId: [customAttribute.customAttributeId],
            sectionCode: [customAttribute.sectionCode],
            formControlId: [customAttribute.formControlId],
            field: [customAttribute.field],
            labelName: [customAttribute.labelName],
            isRequired: [customAttribute.isRequired],
            pickListValues: [customAttribute.pickListValues],
            customAttributeValue: [customAttribute.customAttributeValue,[...this.getCustomValidators(customAttribute)]]
        });
    }

    getAddedCustomAttributes(form) {
        return form.controls.customAttributes.controls;
    }

    addCustomAttribute(customAttribute: WorkflowModelsNS.WorkflowAddEditActionRecordSOCustoms) {
        const control = <FormArray>this.salesOrderForm.get('customAttributes');
        control.push(this.initCustomAttribute(customAttribute));
    }

    getCustomValidators(customAttribute: WorkflowModelsNS.WorkflowAddEditActionRecordSOCustoms): any[] {
        const validators = [];

        if (customAttribute?.isRequired) {
            validators.push(Validators.required);
        }

        return validators;
    }

    isRequiredTouched(control: FormGroup): boolean {
        return control?.invalid && control?.touched;
    }

    onCustomUpload(event, customField: FormGroup, type): void {
        for (let file of event.files) {
            let errors = [];
            this.appMainService.isShowSpinner('uploadFile');
            if (type == 'image') {
                errors = validateFiles(file, 2, this.allowedExtensions);
            }else{
                errors = validateFileSize(file, 2);
            }

            if (errors.length) {
                for (let error of errors) {
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: error.fileName + ": " + error.error
                    });
                }
                this.appMainService.isHideSpinner('uploadFile');
            } else {
                uploadFiles(file, ({ name, content, size, extension }) => {

                    const customAttachment: any = {
                        name: name,
                        extension: extension,
                        content: content,
                        sizeInBytes: size
                    }

                    const addedAttachments = customField.value.customAttributeValue||[];
                    const alreadyAdded = addedAttachments.find(f => f.name === customAttachment.name);

                    if(!alreadyAdded){
                        addedAttachments.push(customAttachment);
                        customField.patchValue({
                            customAttributeValue: addedAttachments
                        })
                    }else{
                        this.messageService.add({ severity: 'warn', summary: 'Exist', detail: `${customAttachment.name} already added.` });
                    }

                    this.appMainService.isHideSpinner('uploadFile');
                });
            }
        }
    }

    removeCustomFile(index: number, customField: FormGroup) {
        const addedAttachments = customField.value.customAttributeValue||[];
        addedAttachments.splice(index, 1);
        customField.patchValue({
            customAttributeValue: addedAttachments.length>0 ? addedAttachments : null
        })
    }

    downloadFile(name, content): void {
        this.fileService.downloadFile(name, content);
    }

    //Custom Attributes End

    getValidators(fieldData: any): any[] {
        const validators = [];

        if (fieldData?.isRequired) {
            validators.push(Validators.required);
        }

        return validators;
    }

    //#endregion

    //#region ***Order Product***

    onProductCancelClicked(e) {
        this.displayProductSelectionModal = false;
    }

    onProductSearchComplete(foundProducts: any){
        if(foundProducts?.length>0){
            const newProducts: any[] = [];
            const alreadyAddedProducts = this.salesOrderForm.getRawValue().workflowCreateRecordProducts?.length ? this.salesOrderForm.getRawValue().workflowCreateRecordProducts : [];

            foundProducts.map(item => {
                let product = alreadyAddedProducts.find(x => x.productId == item.id);
                (product == null) && newProducts.push(item);
            });

            alreadyAddedProducts.map((addedProduct, index)=>{
                let product = foundProducts.find(x => x.id == addedProduct.productId);
                if(product) {
                    const productForm = this.getProductByIndex(index);
                    const newQuantity = productForm.value.productQty + 1;
                    productForm.patchValue({
                        productQty: newQuantity
                    })
                }
            });

            newProducts.map(x => {

                const {addedProduct, recordDetails} = this.addProductFormat(x);

                if(x?.bundleDetails?.length>0){
                    addedProduct.bundleDetails = [];

                    x?.bundleDetails.map(bx=>{
                        const bundDetails = this.addProductFormat(bx);
                        bundDetails.recordDetails.bundleKitParentProductId = recordDetails.productId;
                        // const bundleForm = this.initSalesOrderProduct(bundDetails.addedProduct,bundDetails.recordDetails);
                        addedProduct.bundleDetails.push(bundDetails);
                    })

                }

                this.purchaseListTB.push(addedProduct);
                this.addProduct(addedProduct,recordDetails);
            });
        }
    }

    openProductsDialog() {
        this.moduleName = 'SalesOrder';
        this.bundleIndex = -1;
        this.displayProductSelectionModal = true;
        this.selectedProductsList = ParseHelper.DeepCopy(this.purchaseListTB);
    }

    openProductsDialogForBundle(bundleForm: FormGroup, bundleIndex: number) {
        this.moduleName = "Bundle";
        this.bundleIndex = bundleIndex;
        this.displayProductSelectionModal = true;
        this.selectedProductsList = this.purchaseListTB.find(p=> p.id==bundleForm.value.productId)?.bundleDetails?.map(b=> b.addedProduct)||[];
    }

    isNumberKey(evt) {
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
        return true;
    }

    updateBundleQuantity(bundleForm: FormGroup){
        if(bundleForm.value.typeId==TypeIds.BundleTypeId){
            const quantity = bundleForm.value.productQty||1;
            this.getBundleProducts(bundleForm).controls.map(bundleDetailsForm=>{
                const updatedQuantity = (bundleDetailsForm.value.totalQuantity||1) * quantity;
                bundleDetailsForm.patchValue({
                    productQty: updatedQuantity
                })

            })
        }
    }

    setAddedProducts(){
        this.selectedActionCreateRecord.workflowCreateRecordProducts?.filter(p=> !p.bundleKitParentProductId).map(recordDetails=>{

            const productDetails = this.selectedActionCreateRecord.products.find(p=> p.id==recordDetails.productId);

            const addedProduct: WorkflowModelsNS.WorkflowAddEditActionRecordProductDetails = {
                id: recordDetails.productId,
                name: productDetails.itemNo,
                itemNo: productDetails.itemNo,
                description: productDetails.description,
                productUOM: productDetails.productUOM,
                quantity: recordDetails.productQty,
                totalQuantity: recordDetails.productQty,
                sellPrice: recordDetails.productPrice,
                amount: recordDetails.productQty * recordDetails.productPrice,
                bundleDetails: null
            }

            if([this.typeIds.BundleTypeId, this.typeIds.KitTypeId].includes(recordDetails.typeId)){
                let bundleRecords = this.selectedActionCreateRecord.workflowCreateRecordProducts?.filter(p=> p.bundleKitParentProductId==addedProduct.id);
                addedProduct.bundleDetails = [];
                bundleRecords.map(brecodDetails=>{
                    let bproductDetails = this.selectedActionCreateRecord.products.find(p=> p.id==brecodDetails.productId);

                    if(productDetails?.bundleDetails?.length>0){
                        bproductDetails = productDetails?.bundleDetails.find(b=> b.addedProduct?.id == brecodDetails.productId)?.addedProduct;
                    }



                    const baddedProduct: WorkflowModelsNS.WorkflowAddEditActionRecordProductDetails = {
                        id: brecodDetails.productId,
                        name: bproductDetails?.itemNo,
                        itemNo: bproductDetails?.itemNo,
                        description: bproductDetails?.description,
                        productUOM: bproductDetails?.productUOM,
                        quantity: brecodDetails.productQty,
                        totalQuantity: Math.ceil((brecodDetails.productQty/recordDetails.productQty)),
                        sellPrice: brecodDetails.productPrice,
                        amount: brecodDetails.productQty * brecodDetails.productPrice,
                        bundleDetails: null
                    }

                    addedProduct.bundleDetails.push({
                        addedProduct: baddedProduct,
                        recordDetails: brecodDetails
                    });
                })

            }

            this.purchaseListTB.push(addedProduct);
            this.addProduct(addedProduct,recordDetails);
        })
    }

    onProductAddComplete(event) {
        if(this.bundleIndex>=0){
            this.onBundleProductAddComplete(event);
        }else{
            this.onSingleProductAddComplete(event);
        }
	}

    onSingleProductAddComplete(event){
        this.displayProductSelectionModal = false;
		event = event ? event : [];
		let newProducts: any[] = [];
		const alreadyAddedProducts = this.salesOrderForm.getRawValue().workflowCreateRecordProducts?.length ? this.salesOrderForm.getRawValue().workflowCreateRecordProducts : [];

		event.map(item => {
			let product = alreadyAddedProducts.find(x => x.productId == item.id);
			(product == null) && newProducts.push(item);
		});

        alreadyAddedProducts.map((addedProduct, index)=>{
            let product = event.find(x => x.id == addedProduct.productId);
            if(!product) this.removeProduct(index,addedProduct.productId);
        });

		newProducts.map(x => {

            const {addedProduct, recordDetails} = this.addProductFormat(x);

            if(x?.bundleDetails?.length>0){
                addedProduct.bundleDetails = [];

                x?.bundleDetails.map(bx=>{
                    const bundDetails = this.addProductFormat(bx);
                    bundDetails.recordDetails.bundleKitParentProductId = recordDetails.productId;
                    // const bundleForm = this.initSalesOrderProduct(bundDetails.addedProduct,bundDetails.recordDetails);
                    addedProduct.bundleDetails.push(bundDetails);
                })

            }

            this.purchaseListTB.push(addedProduct);
            this.addProduct(addedProduct,recordDetails);
		});
    }

    onBundleProductAddComplete(event) {
		this.displayProductSelectionModal = false;
		event = event ? event : [];
		let newProducts: any[] = [];
        const bundleForm = this.getProductByIndex(this.bundleIndex) as FormGroup;
		const alreadyAddedProducts = bundleForm.value.bundleDetails?.length ? bundleForm.value.bundleDetails : [];

		event.map(item => {
			let product = alreadyAddedProducts.find(x => x.productId == item.id);
			(product == null) && newProducts.push(item);
		});

        alreadyAddedProducts.map((addedProduct, index)=>{
            let product = event.find(x => x.id == addedProduct.productId);
            if(!product) this.removeBundleProduct(bundleForm,index,addedProduct.productId);
        });

		newProducts.map(x => {
            const {addedProduct, recordDetails} = this.addProductFormat(x);
            recordDetails.bundleKitParentProductId = bundleForm.value.productId;

            if(bundleForm.value.typeId==TypeIds.BundleTypeId){
                recordDetails.productQty = bundleForm.value.productQty * addedProduct.totalQuantity;
            }

            this.purchaseListTB.find(p=> p.id==bundleForm.value.productId)?.bundleDetails.push({
                addedProduct,recordDetails
            });
            this.addBundleProduct(bundleForm,addedProduct,recordDetails);
		});
	}

    addProductFormat(x: any){
        let qty = x.totalQuantity ? Number(x.totalQuantity) : 1;
        let price = x.price ? parseFloat(x.price) : 0;
        price =  this.selectedParentModule?.objectId === VendorModuleId ? parseFloat(x.costPrice) : price
        const addedProduct: WorkflowModelsNS.WorkflowAddEditActionRecordProductDetails = {
            id: x.id,
            name: x.itemNo,
            itemNo: x.itemNo,
            description: x.description,
            productUOM: [],
            quantity: qty,
            totalQuantity: qty,
            sellPrice: price,
            amount: qty * price,
            bundleDetails: null
        }

        x.uom?.map(uom=>{
            addedProduct.productUOM.push({
                ...uom,
                uomName: uom?.uomDetail?.name
            })
        })

        const recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecordProducts = {
            id: 0,
            workflowActionCreateRecordId: 0,
            productId: x.id,
            typeId: x.typeId,
            productUOMId: x?.unit?.uomDetail ? x.unit?.uomDetail?.id : null,
            discountId: null,
            discountTypeId: null,
            discountAmount: 0,
            handlingChargeId: null,
            handlingChargeTypeId: null,
            handlingChargeAmount: 0,
            productQty: qty,
            productPrice: price,
            bundleKitParentProductId: null,
            statusId: Status.Active
        }

       return {addedProduct, recordDetails};
    }

    initSalesOrderProduct(addedProduct: WorkflowModelsNS.WorkflowAddEditActionRecordProductDetails, recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecordProducts){
        const productForm = this.formBuilder.group({
            id: [recordDetails.id],
            workflowActionCreateRecordId: [recordDetails?.workflowActionCreateRecordId],
            productId: [recordDetails.productId],
            typeId: [recordDetails.typeId],
            productUOMId: [recordDetails.productUOMId],
            discountId: [recordDetails.discountId||null],
            discountTypeId: [recordDetails.discountTypeId||null],
            discountAmount: [recordDetails.discountAmount],
            handlingChargeId: [recordDetails.handlingChargeId||null],
            handlingChargeTypeId: [recordDetails.handlingChargeTypeId||null],
            handlingChargeAmount: [recordDetails.handlingChargeAmount],
            calculatedDiscount: [0],
            calculatedHandlingAmount: [0],
            productQty: [recordDetails.productQty],
            totalQuantity: [addedProduct.totalQuantity],
            productPrice: [recordDetails.productPrice],
            bundleKitParentProductId: [recordDetails.bundleKitParentProductId],
            itemNo: [addedProduct.itemNo],
            description: [addedProduct.description],
            productUOM: [addedProduct.productUOM],
            amount: [0],
            subtotal: [0],
            expanded: [false],
            bundleDetails: this.formBuilder.array([])
        });

        if(addedProduct?.bundleDetails?.length>0){
            addedProduct?.bundleDetails.map(bundleDetails=>{
                const bundForm = this.initSalesOrderProduct(bundleDetails.addedProduct,bundleDetails.recordDetails);
                this.getBundleProducts(productForm).push(bundForm)
            })
        }

        if(this.viewOnly){
            productForm.disable();
        }


        return productForm;
    }

    toggleExpand(productForm: FormGroup){
        productForm.patchValue({
            expanded: !productForm.value.productForm
        })
    }

    getBundleProducts(formGroup: FormGroup): FormArray {
        return formGroup.get('bundleDetails') as FormArray;
    }

    getBundleProductByIndex(formGroup: any, index: number) {
        const control = <FormArray>formGroup.get('bundleDetails');
        return control.controls[index];
    }

    getAddedProducts(form) {
        return form.controls.workflowCreateRecordProducts.controls;
    }

    addProduct(addedProduct: WorkflowModelsNS.WorkflowAddEditActionRecordProductDetails, recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecordProducts) {
        const control = <FormArray>this.salesOrderForm.get('workflowCreateRecordProducts');
        control.push(this.initSalesOrderProduct(addedProduct,recordDetails));
    }

    removeProduct(index: number,productId: number) {
        const addedIndex = this.purchaseListTB.findIndex(p=> p.id==productId);
        if(addedIndex>=0) this.purchaseListTB.splice(addedIndex,1);
        const control = <FormArray>this.salesOrderForm.get('workflowCreateRecordProducts');
        control.removeAt(index);
    }

    addBundleProduct(bundleForm: FormGroup,addedProduct: WorkflowModelsNS.WorkflowAddEditActionRecordProductDetails, recordDetails: WorkflowModelsNS.WorkflowAddEditActionCreateRecordProducts) {
        const control = <FormArray>bundleForm.get('bundleDetails');
        control.push(this.initSalesOrderProduct(addedProduct,recordDetails));
    }

    removeBundleProduct(bundleForm: FormGroup, index: number, productId: number) {
        const bundleProduct = this.purchaseListTB.find(p=> p.id==bundleForm.value.productId);
        const addedIndex = bundleProduct?.bundleDetails.findIndex(p=> p.id==productId)
        if(addedIndex>=0 && bundleProduct?.bundleDetails?.length>0){ bundleProduct.bundleDetails.splice(addedIndex,1)}
        const control = <FormArray>bundleForm.get('bundleDetails');
        control.removeAt(index);
    }

    getProductByIndex(index: number) {
        const control = <FormArray>this.salesOrderForm.get('workflowCreateRecordProducts');
        return control.controls[index];
    }

    itemTotalCalulationInit(){
        this.salesOrderForm.get('workflowCreateRecordProducts')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(value => {
                this.calculateTotal(value);
            });

        this.salesOrderForm.get('discountAmount')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(value => {
                const addedProducts = this.salesOrderForm.getRawValue().workflowCreateRecordProducts;
                this.calculateTotal(addedProducts,null,null,value);
            });

        this.salesOrderForm.get('discountId')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(value => {
                const addedProducts = this.salesOrderForm.getRawValue().workflowCreateRecordProducts;
                const discountDetails = this.discountOptions.find(d=> d.id==value);
                this.calculateTotal(addedProducts,null,discountDetails?.id||0,discountDetails?.discountValue||0);
            });

        this.salesOrderForm.get('addlDiscountAmount')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(value => {
                const addedProducts = this.salesOrderForm.getRawValue().workflowCreateRecordProducts;
                this.calculateTotal(addedProducts,null,null,null,null,value);
            });

        this.salesOrderForm.get('addlDiscountId')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(value => {
                const addedProducts = this.salesOrderForm.getRawValue().workflowCreateRecordProducts;
                const discountDetails = this.discountOptions.find(d=> d.id==value);
                this.calculateTotal(addedProducts,null,null,null,discountDetails?.id||0,discountDetails?.discountValue||0);
            });

        this.salesOrderForm.get('handlingChargeAmount')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(value => {
                const addedProducts = this.salesOrderForm.getRawValue().workflowCreateRecordProducts;
                this.calculateTotal(addedProducts,null,null,null,null,null,value);
            });

        this.salesOrderForm.get('handlingChargeId')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(value => {
                const addedProducts = this.salesOrderForm.getRawValue().workflowCreateRecordProducts;
                const handlingDetails = this.additionalFees.find(d=> d.id==value);
                this.calculateTotal(addedProducts,null,null,null,null,null,handlingDetails?.id||0,handlingDetails?.discountValue||0);
            });

        this.salesOrderForm.get('shippingAmount')
            .valueChanges.pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(value => {
                const addedProducts = this.salesOrderForm.getRawValue().workflowCreateRecordProducts;
                this.calculateTotal(addedProducts,value);
            });
    }

    changeRowDiscount($event: any, productControl: FormGroup){
        const discountId = $event?.value;
        const discountDetails = this.discountOptions.find(d=> d.id==discountId);
        productControl.patchValue({
            discountAmount: discountDetails?.discountValue||0
        });
    }

    changeRowHandlingFee($event: any, productControl: FormGroup){
        const handlingChargeId = $event?.value;
        const handlingDetails = this.additionalFees.find(d=> d.id==handlingChargeId);
        productControl.patchValue({
            handlingChargeAmount: handlingDetails?.discountValue||0
        });
    }

    calculateTotal(addedProducts: WorkflowModelsNS.WorkflowAddEditActionCreateRecordProducts[],
        shippingAmount: number = null,
        discountId: number = null,
        discountAmount: number = null,
        addlDiscountId: number = null,
        addlDiscountAmount: number = null,
        handlingChargeId: number = null,
        handlingChargeAmount: number = null)
    {
        let productSubtotal = 0;
		let productTotalAmount = 0;
        let totalDiscount = 0;
        let totalHandlingFee = 0;
        let isTableDiscountEnabled = false;

		addedProducts.map((product, index) => {
            const productForm = this.getProductByIndex(index);
			const qty = product.productQty>0 ? product.productQty : 1;
			const price = product.productPrice>0 ? product.productPrice : 0;
			let itemTotal = qty * price;
            let calculatedDiscount = 0;
            let calculatedHandlingFee = 0;

            //Bundle Product Calculation
            if(product.typeId == TypeIds.BundleTypeId && product.bundleDetails?.length>0){
                let bundleTotal = 0;
                let bundleTotalDiscount = 0;
                let bundleTotalHandlingFee = 0;

                product.bundleDetails.map((bProduct, index)=>{

                    const bProductForm = this.getBundleProductByIndex(productForm,index);
                    const bqty = bProduct.productQty>0 ? bProduct.productQty : 1;
                    const bprice = bProduct.productPrice>0 ? bProduct.productPrice : 0;
                    const bitemTotal = bqty * bprice;
                    let bundleTotalAmount = bitemTotal;
                    let bcalculatedDiscount = 0;
                    let bcalculateHandlingFee = 0;

                    const bDiscountTaxable = this.isDiscountTaxable(bProduct.discountId);
                    const bHandlingFeeTaxable = this.isHandlingFeeTaxable(bProduct.handlingChargeId);
                    const bdiscount = this.discountOptions.find(d=> d.id==bProduct.discountId);
                    const bhandlingDetails = this.additionalFees.find(d=> d.id==bProduct.handlingChargeId);
                    let bdiscountValue = bProduct.discountAmount;
                    let bhandlingValue = bProduct.handlingChargeAmount;

                    if(bDiscountTaxable){
                        if(this.discountEnabled && this.checkedFields?.tbldiscount?.isChecked && bdiscount){
                            isTableDiscountEnabled = true;
                            const dis = this.calculateDiscount(bdiscount.id,bdiscountValue,bundleTotalAmount);
                            bcalculatedDiscount = dis.discount;
                            bdiscountValue = dis.disValue;
                        }else{
                            bdiscountValue = 0;
                        }

                        bundleTotalAmount -= bcalculatedDiscount;

                        //handling fee
                        if(this.checkedFields?.table_handlingfee?.isChecked && bhandlingDetails){
                            const dis = this.calculateHandlingFee(bhandlingDetails.id,bhandlingValue,bundleTotalAmount);
                            bcalculateHandlingFee = dis.fee;
                            bhandlingValue = dis.feeValue;
                        }else{
                            bhandlingValue = 0;
                        }

                        bundleTotalAmount += bcalculateHandlingFee;
                    }else{
                        if(bHandlingFeeTaxable){
                            if(this.checkedFields?.table_handlingfee?.isChecked && bhandlingDetails){
                                const dis = this.calculateHandlingFee(bhandlingDetails.id,bhandlingValue,bundleTotalAmount);
                                bcalculateHandlingFee = dis.fee;
                                bhandlingValue = dis.feeValue;
                            }else{
                                bhandlingValue = 0;
                            }

                            bundleTotalAmount += bcalculateHandlingFee;
                        }

                        if(this.discountEnabled && this.checkedFields?.tbldiscount?.isChecked && bdiscount){
                            isTableDiscountEnabled = true;
                            const dis = this.calculateDiscount(bdiscount.id,bdiscountValue,bundleTotalAmount);
                            bcalculatedDiscount = dis.discount;
                            bdiscountValue = dis.disValue;
                        }else{
                            bdiscountValue = 0;
                        }

                        bundleTotalAmount -= bcalculatedDiscount;

                        if(!bHandlingFeeTaxable){
                            if(this.checkedFields?.table_handlingfee?.isChecked && bhandlingDetails){
                                const dis = this.calculateHandlingFee(bhandlingDetails.id,bhandlingValue,bundleTotalAmount);
                                bcalculateHandlingFee = dis.fee;
                                bhandlingValue = dis.feeValue;
                            }else{
                                bhandlingValue = 0;
                            }

                            bundleTotalAmount += bcalculateHandlingFee;
                        }
                    }


                    bundleTotalDiscount = bundleTotalDiscount + bcalculatedDiscount;
                    bundleTotalHandlingFee = bundleTotalHandlingFee + bcalculateHandlingFee;
                    bundleTotal = bundleTotal + bitemTotal;
                    bProductForm.patchValue({
                        productQty: bqty,
                        productPrice: bprice,
                        discountTypeId: bdiscount?.id||0,
                        discountAmount: bdiscountValue,
                        calculatedDiscount: bcalculatedDiscount,
                        handlingChargeAmount: bhandlingValue,
                        calculatedHandlingAmount: bcalculateHandlingFee,
                        amount: bitemTotal,
                        subtotal: bundleTotalAmount
                    },{onlySelf: true, emitEvent: false})

                });

                itemTotal = bundleTotal;
                calculatedDiscount = bundleTotalDiscount;
                calculatedHandlingFee = bundleTotalHandlingFee;
            }

            //Bundle Product Calculation End
            const pDiscountTaxable = this.isDiscountTaxable(product.discountId);
            const pHandlingFeeTaxable = this.isHandlingFeeTaxable(product.handlingChargeId);
            const pDiscount = this.discountOptions.find(d=> d.id==product.discountId);
            const handlingDetails = this.additionalFees.find(d=> d.id==product.handlingChargeId);
            let itemTotalAmount = itemTotal;
            let discountValue = product.discountAmount;
            let handlingValue = product.handlingChargeAmount;

            if(pDiscountTaxable){
                //Discount
                if(product.typeId !=TypeIds.BundleTypeId && this.discountEnabled && this.checkedFields?.tbldiscount?.isChecked && pDiscount){
                    isTableDiscountEnabled = true;
                    const dis = this.calculateDiscount(pDiscount.id,discountValue,itemTotalAmount);
                    calculatedDiscount = dis.discount;
                    discountValue = dis.disValue;
                }else{
                    discountValue = 0;
                }

                itemTotalAmount -= calculatedDiscount;

                //handling fee
                if(product.typeId !=TypeIds.BundleTypeId && this.checkedFields?.table_handlingfee?.isChecked && handlingDetails){
                    const dis = this.calculateHandlingFee(handlingDetails.id,handlingValue,itemTotalAmount);
                    calculatedHandlingFee = dis.fee;
                    handlingValue = dis.feeValue;
                }else{
                    handlingValue = 0;
                }

                itemTotalAmount += calculatedHandlingFee;
            }else{
                if(pHandlingFeeTaxable){
                    //handling fee
                    if(product.typeId !=TypeIds.BundleTypeId && this.checkedFields?.table_handlingfee?.isChecked && handlingDetails){
                        const dis = this.calculateHandlingFee(handlingDetails.id,handlingValue,itemTotalAmount);
                        calculatedHandlingFee = dis.fee;
                        handlingValue = dis.feeValue;
                    }else{
                        handlingValue = 0;
                    }

                    itemTotalAmount += calculatedHandlingFee;
                }

                //Discount
                if(product.typeId !=TypeIds.BundleTypeId && this.discountEnabled && this.checkedFields?.tbldiscount?.isChecked && pDiscount){
                    isTableDiscountEnabled = true;
                    const dis = this.calculateDiscount(pDiscount.id,discountValue,itemTotalAmount);
                    calculatedDiscount = dis.discount;
                    discountValue = dis.disValue;
                }else{
                    discountValue = 0;
                }

                itemTotalAmount -= calculatedDiscount;

                if(!pHandlingFeeTaxable){
                    //handling fee
                    if(product.typeId !=TypeIds.BundleTypeId && this.checkedFields?.table_handlingfee?.isChecked && handlingDetails){
                        const dis = this.calculateHandlingFee(handlingDetails.id,handlingValue,itemTotalAmount);
                        calculatedHandlingFee = dis.fee;
                        handlingValue = dis.feeValue;
                    }else{
                        handlingValue = 0;
                    }

                    itemTotalAmount += calculatedHandlingFee;
                }
            }

            totalDiscount = totalDiscount + calculatedDiscount;
            totalHandlingFee = totalHandlingFee + calculatedHandlingFee;
            productSubtotal = productSubtotal + itemTotal;
            productTotalAmount = productTotalAmount + itemTotalAmount;

            productForm.patchValue({
                productQty: qty,
                productPrice: price,
                discountTypeId: pDiscount?.id||0,
                discountAmount: discountValue,
                calculatedDiscount: calculatedDiscount,
                handlingChargeAmount: handlingValue,
                calculatedHandlingAmount: calculatedHandlingFee,
                amount: itemTotal,
                subtotal: itemTotalAmount
            },{onlySelf: true, emitEvent: false})
		});

        let payableTotalAmount = productTotalAmount;
        let calculatedDiscount = 0;
        let calculatedHandlingAmount = 0;
        let discountValue = discountAmount===null ? this.salesOrderForm.getRawValue().discountAmount : discountAmount;
        let handlingChargeValue = handlingChargeAmount===null ? this.salesOrderForm.getRawValue().handlingChargeAmount : handlingChargeAmount;
        discountId = discountId===null ? this.salesOrderForm.getRawValue().discountId : discountId;
        handlingChargeId = handlingChargeId===null ? this.salesOrderForm.getRawValue().handlingChargeId : handlingChargeId;
        const footerDiscountTaxable = this.isDiscountTaxable(discountId);
        const footerHandlingFeeTaxable = this.isHandlingFeeTaxable(handlingChargeId);

        if(footerDiscountTaxable){
            //discount
            if(this.discountEnabled && !this.checkedFields?.tbldiscount?.isChecked && !isTableDiscountEnabled && discountId){
                const dis = this.calculateDiscount(discountId,discountValue,payableTotalAmount);
                calculatedDiscount = dis.discount;
                discountValue = dis.disValue;
            }else{
                discountValue = 0;
            }
            payableTotalAmount -= calculatedDiscount;


            //handling fee
            if(this.checkedFields.handlingfee?.isChecked && handlingChargeId){
                const dis = this.calculateHandlingFee(handlingChargeId,handlingChargeValue,payableTotalAmount);
                calculatedHandlingAmount = dis.fee;
                handlingChargeValue = dis.feeValue;
            }else{
                handlingChargeValue = 0;
            }
            payableTotalAmount += calculatedHandlingAmount;

        }else{
            if(footerHandlingFeeTaxable){
                //handling fee
                if(this.checkedFields.handlingfee?.isChecked && handlingChargeId){
                    const dis = this.calculateHandlingFee(handlingChargeId,handlingChargeValue,payableTotalAmount);
                    calculatedHandlingAmount = dis.fee;
                    handlingChargeValue = dis.feeValue;
                }else{
                    handlingChargeValue = 0;
                }

                payableTotalAmount += calculatedHandlingAmount;
            }

            //discount
            if(this.discountEnabled && !this.checkedFields?.tbldiscount?.isChecked && !isTableDiscountEnabled && discountId){
                const dis = this.calculateDiscount(discountId,discountValue,payableTotalAmount);
                calculatedDiscount = dis.discount;
                discountValue = dis.disValue;
            }else{
                discountValue = 0;
            }
            payableTotalAmount -= calculatedDiscount;

            if(!footerHandlingFeeTaxable){
                //handling fee
                if(this.checkedFields.handlingfee?.isChecked && handlingChargeId){
                    const dis = this.calculateHandlingFee(handlingChargeId,handlingChargeValue,payableTotalAmount);
                    calculatedHandlingAmount = dis.fee;
                    handlingChargeValue = dis.feeValue;
                }else{
                    handlingChargeValue = 0;
                }

                payableTotalAmount += calculatedHandlingAmount;
            }
        }

        //additional discount
        let calculatedAddlDiscount = 0;
        let addlDiscountValue = 0;
        if(this.discountEnabled && this.checkedFields.adddiscount?.isChecked){
            addlDiscountValue = addlDiscountAmount===null ? this.salesOrderForm.getRawValue().addlDiscountAmount : addlDiscountAmount;
            addlDiscountId = addlDiscountId===null ? this.salesOrderForm.getRawValue().addlDiscountId : addlDiscountId;
            if(addlDiscountId){
                const dis = this.calculateDiscount(addlDiscountId,addlDiscountValue,payableTotalAmount);
                calculatedAddlDiscount = dis.discount;
                addlDiscountValue = dis.disValue;
            }else{
                addlDiscountValue = 0;
            }
        }
        payableTotalAmount -= calculatedAddlDiscount;
        payableTotalAmount = payableTotalAmount + (shippingAmount||this.salesOrderForm.getRawValue().shippingAmount||0);
        const orderDiscount = isTableDiscountEnabled ? totalDiscount : calculatedDiscount;

        this.salesOrderForm.patchValue({
            lineAmount: productSubtotal,
            lineTotalDiscount: totalDiscount,
            lineTotalHandlingFee: totalHandlingFee,
            subtotal: productTotalAmount,
            calculatedDiscount: orderDiscount,
            discountTypeId: discountId||0,
            discountAmount: discountValue,
            calculatedAddlDiscount: calculatedAddlDiscount,
            addlDiscountTypeId: addlDiscountId||0,
            addlDiscountAmount: addlDiscountValue,
            calculatedHandlingAmount: calculatedHandlingAmount,
            handlingChargeTypeId: handlingChargeId||0,
            handlingChargeAmount: handlingChargeValue,
            orderTotal: payableTotalAmount,
            isTableDiscountEnabled: isTableDiscountEnabled
        },{onlySelf: true, emitEvent: false})
	}

    isDiscountTaxable(discountTypeId: number){
        const discountDetails = this.discountOptions.find(d=>d.id==discountTypeId);
        return discountDetails?.isTaxable||false;
    }

    calculateDiscount(discountTypeId: number,disValue: number, sumTotal: number){
        let discount = 0;
        const discountDetails = this.discountOptions.find(d=>d.id==discountTypeId);
        disValue = disValue||0;
        if(discountDetails?.description && disValue>0){
            const disName = discountDetails?.description;
            if (disName == "%" || disName == "Percentage") {
                disValue = disValue>100 ? 100 : disValue;
                discount = Number(sumTotal * (Number(disValue) / 100) );
            } else if (disName == "$" || disName == "Amount") {
                disValue = disValue>sumTotal ? sumTotal : disValue;
                discount = Number(disValue);
            }
        }

        return {discount,disValue};
    }

    isHandlingFeeTaxable(handlingTypeId: number){
        const handlingDetails = this.additionalFees.find(d=>d.id==handlingTypeId);
        return handlingDetails?.isTaxable||false;
    }

    calculateHandlingFee(handlingId: number,feeValue: number, sumTotal: number){
        let fee = 0;
        const handlingDetails = this.additionalFees.find(d=>d.id==handlingId);
        feeValue = feeValue||0;
        if(handlingDetails?.typeDescription && feeValue>0){
            const disName = handlingDetails?.typeDescription;
            if (disName == "%" || disName == "Percentage") {
                fee = Number(sumTotal * (Number(feeValue) / 100) );
            } else if (disName == "$" || disName == "Amount") {
                fee = Number(feeValue);
            }
        }

        return {fee,feeValue};
    }
    //#region

    //#region ***Dropdown List***

    setTemplate(configs){
        this.orderTemplates = JSON.parse(
            configs.configurationDetails[0].configJSONValue
        );
        this.salesOrderTemplates = this.orderTemplates.find((t) => t.typeId == this.salesOrderForm.getRawValue().selectedChannel?.channelId);
        this.generateCheckFields();
        this.getAllCustomAttributes();
    }

    setPurchaseTemplate(configs){
        const purchaseTemplate = configs.filter(config => config.name == 'Purchase Template')[0];
        this.orderTemplates = JSON.parse(purchaseTemplate?.configurationDetails[0].configJSONValue);
        this.salesOrderTemplates = this.orderTemplates.find((t) => t.producttypeId == this.salesOrderForm.getRawValue().selectedChannel?.channelId);
        this.generateCheckFields();
        this.getAllCustomAttributes();
    }

    getAllCustomAttributes() {
        let orderObjId = this.orderObjId;
        if([PurchaseOrderModuleId,BillOrderModuleId,VendorCreditModuleId].includes(this.selectedRecordModule?.id)){
            orderObjId = PurchaseOrderModuleId;
        }

        this.appMainService.isShowSpinner("loadCustomAttributes");
        this.productsService
            .getAllCustomFields(orderObjId)
            .then((fields) => {
                this.orderCustomAttributes = _.cloneDeep(fields);
                this.setCustomAttributes();
                this.appMainService.isHideSpinner("loadCustomAttributes");
            }).catch(error=>{
                this.appMainService.isHideSpinner("loadCustomAttributes");
            });
    }

    setCustomAttributes(){
        if(this.orderCustomAttributes && this.salesOrderTemplates){
            this.combinedCustomFields = this.utilityService.getCustomAttributesForCommon(this.salesOrderTemplates, this.orderCustomAttributes);
            this.generateCustomAttributeFields();
        }
    }

    getAllLocations(){
        this.productSelectionService.getAllLocations("0", "0", "").subscribe({
            next: (response)=>{
                let arr: any[] = [];
                response = response||[];
                response?.map( l => {
                    let eachWHouse = {
                        id: l.id,
                        name: l.locationId + " - " + l.name,
                        locationId: l.locationId,
                        contactName: l.contactPersonName,
                        state: l.state,
                        country: l.country,
                        isDefault: l.isDefault,
                        IsDefault: l.isDefault == true ? "Yes" : "No",
                        qty: l.qtyInStock,
                        statusId: l.statusId,
                    };
                    arr.push(eachWHouse);
                })
                this.allLocations = JSON.parse(JSON.stringify(arr));
                let selectedLocation = this.allLocations.find(l=> l.isDefault);

                if(this.selectedActionCreateRecord?.locationId){
                    selectedLocation = this.allLocations.find(l=> l.id == this.selectedActionCreateRecord?.locationId)||selectedLocation;
                }

                this.salesOrderForm.patchValue({
                    selectedLocation: selectedLocation
                });

            }
        });
    }
    //#endregion

    //#region ***Data Format***
    generateCheckFields(){
        const checkFields = {};
        const checkedFieldList = [];
        const formFields = ParseHelper.DeepCopy(WF_SO_FORM_FIELDS);
        this.tableFieldsCount = 0;

        formFields.map((section, sectionInex)=>{
            section.fields.map(fieldDetails=>{

                if([VendorCreditModuleId,BillOrderModuleId].includes(this.selectedRecordModule?.id)){
                    if(fieldDetails.settingFieldName=='item'){
                        fieldDetails.settingFieldName = 'itemno';
                    }else if(fieldDetails.settingFieldName=='rate'){
                        fieldDetails.settingFieldName = 'cost';
                    }
                }

                if([CMOrderModuleId].includes(this.selectedRecordModule?.id)){
                    if(fieldDetails.settingFieldName=='order total'){
                        fieldDetails.settingFieldName = 'ordertotal';
                    }
                }

                // if([PurchaseOrderModuleId,VendorCreditModuleId,BillOrderModuleId].includes(this.selectedRecordModule?.id)){
                //     if(fieldDetails.settingFieldName=='totalamount'){
                //         fieldDetails.settingFieldName = 'amount';
                //     }else if(fieldDetails.settingFieldName=='amount'){
                //         fieldDetails.settingFieldName = 'totalamount';
                //     }
                // }

                const checkfield = this.salesOrderTemplates[section.sectionCode].find(field=> field.code==fieldDetails.settingFieldName || field?.name?.toLowerCase()==fieldDetails.settingFieldName);
                 checkFields[fieldDetails.formFieldname] = checkfield ?
                    {
                        ...checkfield,
                        code: fieldDetails.settingFieldName,
                        labelName: checkfield.labelname||checkfield.name,
                        formFieldname: fieldDetails.formFieldname
                    } :{};

                 checkedFieldList.push(checkFields[fieldDetails.formFieldname]);

                 if(section.sectionCode=='labels_table' && checkFields[fieldDetails.formFieldname].isChecked) this.tableFieldsCount++;
            })
        });
        this.checkedFieldList = ParseHelper.DeepCopy(checkedFieldList);
        this.checkedFields = checkFields;
    }
    //#endregion

    closeCreateRecord(){
        this.displayCreateRecordDialog = false;
        this.dialogClosed.emit(true);
    }

    //quantity
    getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if (value) {
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }
    getQtyDecimalDigits() {
        this.importService
            .getQtyDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe((value) => {
                if (value) {
                    this.qtyFractionDigits = value;
                }
            });
    }
    fetchUnitOfMeasureCategories() {
        this.salesOrderService.fetchUnitOfMeasureCategories().subscribe(resp=>{
            this.measurementUnits  = resp
          })
    }

    getDecimalPlacesCached(productUOM: any[], unitOfMeasureId: number): number {
        const uom = productUOM?.find(unit => unit.unitOfMeasureId === unitOfMeasureId);
        const categoryId = uom?.uomDetail?.categoryId;

        if (!categoryId) {
            return this.qtyFractionDigits; // Default fallback if categoryId is not found
        }

        if (!(categoryId in this.decimalPlacesMap)) {
            this.decimalPlacesMap[categoryId] = this.getDecimalPlaces(categoryId);
        }
        return this.decimalPlacesMap[categoryId];
    }

    getDecimalPlaces(categoryId: number): number {
        return this.measurementUnits?.some(unit => unit?.id === categoryId && unit.name?.toLowerCase() === 'count')
            ? 0
            : this.qtyFractionDigits;
    }

    get lineAmountFieldCount(){
        let count = 0;
        if(this.checkedFields.totalamount?.isChecked) count++;
        if(this.discountEnabled && this.checkedFields.tbldiscount?.isChecked) count++;
        if(this.footerTaxEnabled && this.checkedFields.tbltax?.isChecked) count++;
        if(this.checkedFields.table_handlingfee?.isChecked) count++;

        return count;
    }


    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
